import { detectLinks } from '@/shared/utilities/link-detector';
import { Typography } from '@mui/material';
import type React from 'react';

interface TextWithLinksProps {
  text: string;
  variant?: 'inherit' | 'body1' | 'body2' | 'caption';
  className?: string;
  sx?: any;
}

export const TextWithLinks: React.FC<TextWithLinksProps> = ({ text, variant = 'inherit', className, sx }) => {
  const links = detectLinks(text);

  // If no links found, render as plain text
  if (links.length === 0) {
    return (
      <Typography variant={variant} className={className} sx={sx}>
        {text}
      </Typography>
    );
  }

  // Split text into parts and render with links
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  links.forEach((link) => {
    // Add text before the link
    if (link.startIndex > lastIndex) {
      const beforeText = text.substring(lastIndex, link.startIndex);
      parts.push(beforeText);
    }

    // Add the link
    parts.push(
      <a
        key={`link-${link.startIndex}-${link.endIndex}`}
        href={link.url}
        target='_blank'
        rel='noopener noreferrer'
        className='mex:cursor-pointer text-blue-600 underline hover:text-blue-800 mex:dark:text-blue-400 mex:dark:hover:text-blue-300'
        onClick={(e) => {
          e.stopPropagation();
          // Optional: Add analytics or custom handling here
        }}
      >
        {link.text}
      </a>
    );

    lastIndex = link.endIndex;
  });

  // Add remaining text after the last link
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return (
    <Typography variant={variant} className={className} sx={sx}>
      {parts}
    </Typography>
  );
};
